import { customerDataSchema } from "@aws-portal/core/schemas/marketplace/marketplace.model";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
const INITIAL_STATE = null;
const useCustomerStore = create()(persist((set)=>({
        customer: INITIAL_STATE,
        actions: {
            persistCustomer: (customer)=>{
                set({
                    customer
                });
            },
            resetCustomer: ()=>{
                set({
                    customer: INITIAL_STATE
                });
            },
            validateCustomerData: ({ candidateCustomerIdentifier, candidateCustomerAWSAccountID, candidateProductCode })=>{
                const result = customerDataSchema.safeParse({
                    customerIdentifier: candidateCustomerIdentifier,
                    customerAWSAccountID: candidateCustomerAWSAccountID,
                    productCode: candidateProductCode
                });
                if (!result.success) {
                    return {
                        success: false
                    };
                }
                return {
                    success: true,
                    customer: result.data
                };
            }
        }
    }), {
    name: 'signup-customer-storage',
    partialize: (state)=>({
            customer: state.customer
        }),
    storage: createJSONStorage(()=>localStorage)
}));
export default function useCustomer() {
    const customer = useCustomerStore((state)=>state.customer);
    const actions = useCustomerStore((state)=>state.actions);
    return {
        customer,
        ...actions
    };
}
